import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resCreatePayment {
  message: string;
  success: boolean;
  result: [
    {
      IMAGE: string,
      PAYMENT_ID: string,
      TITLE: string,
      PRICE: number,
      QR_CODE: string,
      BAR_CODE: string,
      FREE: boolean,
      TEMPLATE_TYPE: string,
      MEASURE_ID: string,
    }
  ]
}

interface resPayByTransfer {
  message: string;
  success: boolean;
  result: [
    {
      PAYMENT_ID: string,
      TRANFER_DATE: Date,
      TRANFER_HR: number,
      TRANFER_MIN: number,
      TRANFER_PRICE: number,
      slip: File
    }
  ]
}

interface resCreateQRPayment {
  message: string;
  success: boolean;
  result:
  {
    QR_BASE64: string,
    QRID: string,
    EXP_QR: string,
    AMOUNT: string,
    MERCHANT_NAME: string
  }
}

interface resGetStatusPaymentById {
  message: string;
  success: boolean;
  result: [
    {
      PAYMENT_ID: string,
      REF_ID: string,
      CREATE_DATE: string,
      USER_ID: string,
      TYPE: string,
      UPDATE_DATE: string,
      PRICE: number,
      STATUS_PAYMENT: string,
      EXP_DATE: string,
      PAYMENT_NAME: string,
      PAYMENT_PHONENUMBER: string,
      TAX_NO: string,
      ADDRESS: string,
      SPECIALPRICE: number,
      STANDARTPRICE: number,
      SIGNATURE_ID: number,
      USERNAME: string,
      RECEIPT_ID: string,
      Detail: [],
      ACCOUNTING_ID: string
    }
  ]
}

interface resSaveBase64ReceiveBill {
  message: string;
  success: boolean;
  result:
  {
    PAYMENT_ID: string,
  }
}

interface resCreate2c2pPayment {
  success: boolean,
  message: string,
  result: {
    webPaymentUrl: string,
    paymentToken: string,
    respCode: string,
    respDesc: string
  }
}

@Injectable({
  providedIn: 'root'
})

export class PaymentService {
  token: string = null;

  billerForm;
  receiptBody;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.token = this.authService.getToken(); if (!this.token) { this.token = environment.KEY; }
  }


  createPayment(body) {
    const headers = new HttpHeaders({ Authorization: this.token })
    // console.log(body);

    return this.http.post<resCreatePayment>(environment.URL + '/payment/createPayment', body, { headers });
  }

  getDataFormPayment(form) {
    this.billerForm = form;
    // console.log(this.billerForm);
  }

  payByTransfer(evidence) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let formData = new FormData;
    // console.log(evidence);

    for (let i = 0; i < evidence.evidence.fileList?.length; i++) {
      formData.append('evidences', evidence.evidence.fileList[i].originFileObj);
    }

    formData.append('NAME', this.billerForm.value.name)
    formData.append('PHONENUMBER', this.billerForm.value.phone)
    formData.append('ADDRESS', this.billerForm.value.address)
    formData.append('TAX_NO', this.billerForm.value.tax)
    formData.append('PAYMENT_ID', evidence.PAYMENT_ID);
    formData.append('TRANFER_DATE', evidence.TRANFER_DATE);
    formData.append('TRANFER_HR', evidence.TRANFER_HR);
    formData.append('TRANFER_MIN', evidence.TRANFER_MIN);
    formData.append('TRANFER_PRICE', evidence.TRANFER_PRICE);
    formData.append('slip', evidence.slip);

    return this.http.post<resPayByTransfer>(environment.URL + '/payment/payByTransfer', formData, { headers });
  }

  createQRPayment(body) {
    const headers = new HttpHeaders({ Authorization: this.token })
    // console.log(body);

    return this.http.post<resCreateQRPayment>(environment.URL + '/payment/createQRPayment', body, { headers });
  }

  getStatusPaymentById(pid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetStatusPaymentById>(environment.URL + '/payment/getStatusPaymentById?PAYMENT_ID=' + pid, { headers: headers })
  }

  saveBase64ReceiveBill(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resSaveBase64ReceiveBill>(environment.URL + '/payment/saveBase64ReceiveBill', body, { headers });
  }

  saveBase64ReceiveBillSndMail(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resSaveBase64ReceiveBill>(environment.URL + '/payment/saveBase64ReceiveBillSndMail', body, { headers });
  }

  create2c2pPayment(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resCreate2c2pPayment>(environment.URL + '/payment/2C2PPaymentToken', body, { headers });
  }

  scbInquiry(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post(environment.URL + '/payment/scbInquiry', body, { headers });
  }

}
